import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_LIST,
} from './actions';
import { DETECTION_MODULE } from '../../configs/moduleNames';
import { createLoadListReducer } from '../../utils/getCrudConfig';

const initialState = {
  listMeta: {},
  loadingList: false,
  list: [],
};

const reducer = handleActions({
  ...createLoadListReducer(DETECTION_MODULE + LOAD_LIST, 'list', 'loadingList'),
}, initialState);

export default reducer;

export const getDetectionData = createSelector(
  [state => state[DETECTION_MODULE]],
  state => {
    const {
      listMeta,
      loadingList,
      list,
    } = state;
    return {
      listMeta,
      loadingList,
      list,
    };
  },
);
